import { Component, Event, EventEmitter, h, Prop, State } from '@stencil/core';

import { Appearance } from '@entities/Appearance';
import { Design } from '@entities/Design';
import { WidgetPosition } from '@entities/WidgetPosition';

@Component({
  tag: 'wog-connection-error',
})
export class ConnectionError {
  @Prop() position: WidgetPosition;
  @Prop() design: Design;
  @Prop() themeColor: string;
  @Prop() appearance: Appearance;
  @Prop() trackingId: string;
  @State() isLoading = false;
  @Event() connectWindowClose: EventEmitter<void>;
  @Event() fetchData: EventEmitter<{ trackingId: string }>;

  private handleRatingClose = () => {
    this.connectWindowClose.emit();
  };

  private handleTryAgain = () => {
    this.isLoading = true;
    this.fetchData.emit({ trackingId: this.trackingId });
    setTimeout(() => {
      this.isLoading = false;
    }, 5000);
  };

  render() {
    const elementClasses = {
      'wog--tab-view-container': true,
      'wog--flex': true,
      'wog--flex-col': true,
      'wog--items-center': true,
      'wog--justify-center': true,
      'wog--px-6': true,
      'wog--py-4': true,
      'wog--connection-error': true,
      'wog--mobile-full-position': true,
      'wog--position-left-side': this.position === WidgetPosition.MiddleLeft,
      'wog--position-right-side': this.position === WidgetPosition.MiddleRight,
      'wog--position-bottom-left': this.position === WidgetPosition.BottomLeft,
      'wog--position-bottom-right': this.position === WidgetPosition.BottomRight,
    };
    const submitButtonStyle = {
      'wog--button': true,
      'wog--inline-flex': true,
      'wog--items-center': true,
      'wog--opacity-50': this.isLoading,
      'wog--cursor-pointer': !this.isLoading,
      'wog--cursor-not-allowed': this.isLoading,
    };
    const backgroundStyles = {
      backgroundColor: this.design !== Design.SmileyFace ? this.themeColor : '#333333',
    };
    const textStyles = {
      color: this.appearance === Appearance.Light ? 'white' : '#333333',
    };
    return (
      <div class={elementClasses}>
        <div class="wog--w-full wog--px-4">
          <wog-close-button onClose={() => this.handleRatingClose()} />
          <div class="wog--flex wog--items-center wog--justify-center">
            <svg
              viewBox="0 0 20 20"
              fill="currentColor"
              class="wog--h-12 wog--w-12 wog--text-theme-black">
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <h3 class="wog--text-foundation wog--base-title wog--satisfaction-animation wog--text-center wog--text-theme-black">
            Sorry, something went wrong.
          </h3>
          <p class="wog--text-foundation wog--base-title wog--mb-2 wog--text-center wog--font-normal wog--text-theme-black">
            Please check your connection and try again.
          </p>
          <div class="wog--flex wog--items-center wog--justify-center">
            <button
              type="button"
              class={submitButtonStyle}
              style={{ ...backgroundStyles, ...textStyles }}
              disabled={this.isLoading}
              onClick={this.handleTryAgain}>
              {this.isLoading && (
                <svg
                  class="wog--animate-spin wog--h-5 wog--w-5 wog--text-current"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none">
                  <circle
                    class="wog--opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  />
                  <path
                    class="wog--opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              <span class={{ 'wog--pl-2': this.isLoading }}>Try Again</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
